import { render, staticRenderFns } from "./rich-text-editor.component.vue?vue&type=template&id=0145e270&scoped=true&"
import script from "./rich-text-editor.component.ts?vue&type=script&lang=js&"
export * from "./rich-text-editor.component.ts?vue&type=script&lang=js&"
import style0 from "./rich-text-editor.component.css?vue&type=style&index=0&id=0145e270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0145e270",
  null
  
)

export default component.exports